import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export function PaymentFailurePopup({
  // onRetry,
  onClickOk,
}: {
  // onRetry: () => void;
  onClickOk: () => void | Promise<void>;
}): JSX.Element {
  return (
    <Dialog
      open
      maxWidth="md"
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '600px', md: '700px' },
          borderRadius: 3,
          p: 1,
        },
      }}>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 22,
          pb: 1,
        }}>
        Payment Failed
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 4, py: 2 }}>
        <Box display="flex" justifyContent="center" mb={1}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 48 }} />
        </Box>

        <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
          Your payment could not be processed.
        </Typography>

        {/* <Typography variant="body2" color="text.secondary">
          You can retry the payment or continue with offline mode.
        </Typography> */}
      </DialogContent>
      <DialogActions
        sx={{
          px: 4,
          pb: 3,
          pt: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}>
        {/* <Button
          onClick={onRetry}
          variant="contained"
          fullWidth
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.4,
            fontSize: 16,
          }}
        >
          Retry Payment
        </Button> */}
        <Button
          onClick={() => onClickOk()}
          variant="contained"
          fullWidth
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.4,
            fontSize: 16,
          }}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
